import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../appUtils/axiosConfig";


const initialState = {

    isLoading: false,
    error: null,
    tags: [],
    activetags: [],
    isTagsLoading: false

}


export const getTags = createAsyncThunk(
    'get_tags_page',
    async (_, { dispatch, rejectWithValue }) => {

        try {
            dispatch(getTagsStart());
            const response = await axios.get(`/tags/get_tags.php`)
            console.log('response of tags', response?.data)
            if (response?.data?.status === 'success') {
                // Transform API data to UI format
                dispatch(getTagsSuccess(response?.data))
            }

            return response?.data?.data
        } catch (error) {
            dispatch(getTagsFailure(error.response.data.message))
        }
    }
)
export const getActiveTags = createAsyncThunk(
    'get_tags_page',
    async (_, { dispatch, rejectWithValue }) => {

        try {
            dispatch(getActiveTagsStart());
            const response = await axios.get(`/tags/get_active_tags.php`)
            console.log('response of tags', response?.data)
            if (response?.status === 200) {
                // Transform API data to UI format
                dispatch(getActiveTagsSuccess(response?.data))
            }

            return response?.data?.data
        } catch (error) {
            dispatch(getActiveTagsFailure(error.response.data.message))
        }
    }
)
export const addTag = createAsyncThunk(
    "addtags",
    async (data, { dispatch, rejectWithValue }) => {
        const formData = new FormData();
        formData.append("title", data.title);
        formData.append("status", data.status);
        try {
            dispatch(addTagsStart());
            // Transform UI data to API format before sending
            const response = await axios.post(`/tags/add_tag.php`, formData);
            dispatch(addTagsSuccess(response.data?.user));
            if (response?.data?.status === 'success') {
                dispatch(getTags())
                // SHOW_SUCCESS_NOTIFICATION("Login Successfully");
            }
            return response.data
        } catch (error) {
            dispatch(addTagsFailure(error.response.data.message));
            // SHOW_ERROR_NOTIFICATION(error.response.data.message);
            return rejectWithValue(error.response.data.message);
        }
    }
);
export const deleteTag = createAsyncThunk('deletetag', async (id, { dispatch, rejectWithValue }) => {
    try {
        dispatch(updateTagsStart());
        const response = await axios.delete(`/tags/delete_tags.php?id=${id}`);
        if (response?.data?.status === 'success') {
            dispatch(getTags())
            // SHOW_SUCCESS_NOTIFICATION("Login Successfully");
        }
        return response.data
    } catch (error) {
        // SHOW_ERROR_NOTIFICATION(error.response.data.message);
        return rejectWithValue(error.response.data.message);
    }
})
export const updateTag = createAsyncThunk(
    "hsn/updateHsn",
    async ({ id, data }, { dispatch, rejectWithValue }) => {
        console.log("Updating HSN — ID:", id, "Data:", data);

        try {
            dispatch(updateTagsStart());

            // Send to API as expected (id + payload)
            const response = await axios.post(`/tags/update_tag.php`, {
                id,
                ...data,
            });

            if (response?.data?.status === "success") {
                dispatch(updateTagsSuccess(response.data?.hsn));
                dispatch(getTags()); // refresh list
            } else {
                dispatch(updateTagsFailure(response.data.message));
                return rejectWithValue(response.data.message);
            }

            return response.data;
        } catch (error) {
            const msg = error?.response?.data?.message || "Failed to update HSN";
            dispatch(updateTagsFailure(msg));
            return rejectWithValue(msg);
        }
    }
);

const tagsSlice = createSlice({
    name: 'tagsReducer',
    initialState,
    reducers: {
        getTagsStart(state) {
            state.isLoading = true;
            state.error = null;
        },
        getTagsSuccess(state, action) {

            state.tags = action.payload;
            state.isLoading = false;
        },
        getTagsFailure(state, action) {
            state.tags = null;
            state.isLoading = false;
            state.error = action.payload;

        },
        getActiveTagsStart(state) {
            state.isLoading = true;
            state.error = null;
        },
        getActiveTagsSuccess(state, action) {

            state.activetags = action.payload;
            state.isLoading = false;
        },
        getActiveTagsFailure(state, action) {
            state.activetags = null;
            state.isLoading = false;
            state.error = action.payload;

        },
        addTagsStart(state) {
            state.isTagsLoading = true;
            state.error = null;
        },
        addTagsSuccess(state, action) {
            state.user = action.payload;
            state.isTagsLoading = false;
        },
        addTagsFailure(state, action) {
            state.error = action.payload;
            state.isTagsLoading = false;
        },

        updateTagsStart(state) {
            state.isTagsLoading = true;
            state.error = null;
        },
        updateTagsSuccess(state, action) {
            state.user = action.payload;
            state.isTagsLoading = false;
        },
        updateTagsFailure(state, action) {
            state.error = action.payload;
            state.isTagsLoading = false;
        },
    }
})

export const { getTagsSuccess, getTagsStart, getTagsFailure, getActiveTagsSuccess, getActiveTagsStart, getActiveTagsFailure, addTagsStart, addTagsSuccess, addTagsFailure, updateTagsStart, updateTagsSuccess, updateTagsFailure } = tagsSlice.actions;

export default tagsSlice.reducer;